import { PermisosService, Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { EspacioFormulario } from '../../domain/EspacioFormulario';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService } from 'ng2-translate';
import { Message, SelectItem } from 'primeng/primeng';
import { Tablita } from '../../domain/Tablita';
import { InformesService } from '../../providers/informes/informes.service';
import { Contenido } from '../../domain/Contenido';
import { HistoricoLocalizacionContenido } from '../../domain/HistoricoLocalizacionContenido';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { CoincidenciasLocalizacionContenidos } from '../../domain/CoincidenciasLocalizacionContenidos';
import { Observable, Subscription } from '../../../../node_modules/rxjs';
import { timer } from '../../../../node_modules/rxjs/observable/timer';
import { ActivatedRoute } from '@angular/router';
import { Exportar } from '../../service/exportar.service';
import { Idioma } from '../../domain/Idioma';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { nodeValue } from '@angular/core/src/view';
/*
import * as jsPDF  from 'jspdf'
import  Canvg  from 'canvg';
//import * as svg2pdf from 'svg2pdf.js';
import html2canvas from 'html2canvas';
import * as html2pdf from 'html2pdf.js';
*/


import { environment } from '../../../environments/environment';
import { ok } from 'assert';
import { SeccionFormulario } from '../../domain/SeccionFormulario';
const FILTRO_INI = JSON.stringify({
	where: {
		Titulo: '',
		Descripcion: '',
		Tipo: '',
		PermaneceDesde: '',
		FechaAlta: '',
		FechaBaja: '',
		Seccion: ''
	},
	order: 'Titulo DESC',
	top: 10,
	page: 0,
	total: 0
});

@Component({
	templateUrl: './Informes.component.html',
	styleUrls: ['./Informes.component.scss'],
    providers: [ConfirmationService, Exportar]
})
export class InformesComponent implements OnInit, OnDestroy {
	fechaInicioAutoRefrescoTablaTiempoReal = new Date();
	segundos = new Date();
	fechaAutoRefrescoTablaTiempoReal = new Date();

	fechaInicioAutoRefrescoToken = new Date();
	fechaAutoRefrescoToken = new Date();

	spinner: HTMLElement;
	msgs: Message[] = [];

    autorefrescoChecked: boolean = false;

	public informesList: Contenido[] = [];
	public historicosList: HistoricoLocalizacionContenido[];
	public historicoSeccionesList: HistoricoLocalizacionContenido[];
	public historicoTipologiaSeccionesList: HistoricoLocalizacionContenido[];
	public TablitaList: Contenido[];
	public coincidenciasList: CoincidenciasLocalizacionContenidos[];

	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	public permisos: Permisos = new Permisos();

    public tipologias_contenido_seleccionadas: any[] = [];
	public tipologias_seccion_seleccionadas: any[] = [];
	public contenidos_seleccionados: any[];
	public secciones_seleccionados: any[];


	public tipo_informe_seleccionado;
	public time_selected;
	public TimeCoincidencia_selected;
	public time_last_to_show_selected;
	public time_ubication;
	public opcion_desde_selected;
	public opcion_hasta_selected;
	public startHourDefault;
	public finHourDefault;
	public op_desde;
	public op_hasta;


    public opcionesSelectorTipoInforme: SelectItem[] = [];
	public opcionesTimeSelector: SelectItem[] = [];
	public opcionesTimeCoincidenciaSelector: SelectItem[] = [];
	public opcionesTimeLastToShowSelector: SelectItem[] = [];
	public opcionesTiempoUbicacionSelector: SelectItem[] = [];
    public opcionesSelectorTipologia: SelectItem[]  = [];
	public opcionesSelectorTipologiaSeccion: SelectItem[]  = [];
    public opcionesSelectorContenido: Contenido[]  = [];
	public opcionesSelectorSeccion: SelectItem[] = [];
	public auxOpcionesSelectorSeccion: SelectItem[] = [];
	public opcionesContenidos: Contenido[] = [];
	ocultarAutorefrescar: boolean = true;
	ocultarTimeAutorefrescar: boolean = true;
	ocultarTimeCoincidencia: boolean = true;
	ocultarDesdeHasta: boolean = true;
	ocultarfiltrar: boolean = true;
	duracionUbicacion: boolean = false;
	planoVisible: boolean = true;
	tablitaVisible: boolean = true;
	OcultarExportar: boolean = true;
	public fAltaError = false;
	public fBajaError = false;

	// Visibilidad de Secciones
	ocultarVistaLocalizacionActual: boolean = true;
	ocultarVistaHistoricos: boolean = true;
	ocultarVistaSecciones: boolean = true;
	ocultarVistaOcupacion: boolean = true;
	ocultarVistaCoincidencias: boolean = true;
	ocultarVistaTipologiaSecciones: boolean = true;
	// InformeSeleccionada
	idiomaCalendario: IdiomaCalendario;

	menuTipologiaContenidoError: boolean;
	menuTipoInformeError: boolean;
	menuContenidoError: boolean;
	fDesdeError: boolean;
	fHastaError: boolean;
	NoHayInfoError1: boolean;
	NoHayInfoError2: boolean;
	NoHayInfoError3: boolean;
	maxRows: boolean;
	minRows: boolean;
	tiempoMinimoCoincidenciaError: boolean;



	private subscriptionRenovarTablaTiempoReal: Subscription;
	private subscriptionRenovarToken: Subscription;

	TIEMPO_AUTOREFRESCO_TOKEN = 300; // 5 minutos
	TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL = 60; // 1 minuto
	everyMin: Observable < number >  = timer(0, this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL * 1000);
	// every15: Observable < number >  = timer(0, this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL * 1000);
	// everyhour: Observable < number >  = timer(0, this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL * 1000);

	VISTA_LOCALIZACION_TIEMPO_REAL = 0;
	VISTA_HISTORICOS_LOCALIZACION = 1;
	VISTA_HISTORICOS_SECCION = 2;
	VISTA_COINCIDENCIAS_UBICACION = 3;
	VISTA_OCUPACION = 4;
	VISTA_HISTORICOS_TIPOLOGIA_SECCION = 5;


	// variables Exportar
	public filtro = JSON.parse(FILTRO_INI);
	@ViewChild('pg_contenidos') pg_contenidos;
	triggerPageChange: boolean = true;
	idiomaSeleccionado: Idioma;
	tipologiasMostrar: any[];
	tipologiasSeccionesMostrar: any[];
	contenidosMostrar: SelectItem[] = [];
	ocultarMostrarSecciones: boolean = true;
	mostrarSecciones: boolean = true;
	infoInforme: string = '';
	positionDialogInfoInformeY: number;
	positionDialogInfoInformeX: number;

	dialogDescripcionInforme: boolean = false;
	constructor(
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService,
		private permisosService: PermisosService,
		private informeService: InformesService,
		private route: ActivatedRoute,
		private exportador: Exportar
	) {
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Informes.Informes') }
		]);

		console.log('*** InformesComponent ***');

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
        this.spinner.style.display = 'none';

		this.informesList = [];
		this.historicosList = [];
		this.TablitaList = [];
		this.coincidenciasList = [];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.filtro = this.authService.getFiltroContenido();

		this.startHourDefault = new Date();
		this.startHourDefault.setHours(0, 0, 0, 0);
		this.finHourDefault = new Date();
		this.finHourDefault.setHours(23, 59, 59, 999);
		this.time_ubication = 0;


    }

	ngOnInit() {
		const that = this;

		that.opcionesSelectorTipoInforme = [
			{
                value: 0,
                label: this.translate.instant('Informes.localizacion') // 'Localización en tiempo real'
            },
            {
                value: 1,
                label: this.translate.instant('Informes.historico') // 'Histórico de ubicaciones'
            },
			{
                value: 2,
                label: this.translate.instant('Informes.seccion') // 'Histórico de Secciones'
            },
			{
                value: 5,
                label: this.translate.instant('Informes.tipologiaseccion') // 'Ocupación'
            },
            {
                value: 3,
                label: this.translate.instant('Informes.coincidencia') // 'Coincidencias de ubicación'
            },
            {
                value: 4,
                label: this.translate.instant('Informes.ocupacion') // 'Ocupación'
            }
		];

		const _filtroSaved = this.authService.getFiltroContenido();

		if (_filtroSaved){
			this.filtro = _filtroSaved;
		}
		this.route.queryParams
		.subscribe(params => {
			const _elemento = params['elemento'];
			that.filtro = JSON.parse(FILTRO_INI);

			if (_elemento){
				that.filtro.where.Titulo = _elemento;
			}
		});
		// this.tipo_informe_seleccionado = [];
		this.tipologias_contenido_seleccionadas = [];
		this.tipologias_seccion_seleccionadas = [];
		this.contenidos_seleccionados = [];
		this.secciones_seleccionados = 	[];

		this.informeService.obtenerTipologias()
		.then(function(tipologias){
			that.opcionesSelectorTipologia = tipologias;
			that.opcionesSelectorTipologia.sort((one: any, two: any) => {
				var textA = one.Nombre.toUpperCase();
				var textB = two.Nombre.toUpperCase();
				return textA.localeCompare(textB);
			});
			that.refrescarContenidosTipologiasSeleccionadas(undefined);
			console.log(that.opcionesSelectorTipologia)
			return that.permisosService.obtenerTIPOLOGIA_SECCION()
		})
		.then(function(tipologiasSecciones){
			tipologiasSecciones = tipologiasSecciones.filter(o => o.Activa === true);
			that.opcionesSelectorTipologiaSeccion = tipologiasSecciones;
			if(that.opcionesSelectorTipologiaSeccion.length < 1){
				that.opcionesSelectorTipoInforme = that.opcionesSelectorTipoInforme.filter(o => o.value !== 5);
			}
			//that.opcionesSelectorSeccion = that.opcionesSelectorSeccion.filter( (a:any) => a.Nombre !== null && a.Nombre !== 'Default')
			that.opcionesSelectorTipologiaSeccion.sort((one: any, two: any) => {
				var textA = one.Nombre.toUpperCase();
				var textB = two.Nombre.toUpperCase();
				return textA.localeCompare(textB);
			});
			console.log(that.opcionesSelectorTipologiaSeccion)
			return that.informeService.obtenerSecciones()
		})
		.then(function(secciones){
			console.log(secciones)
			that.opcionesSelectorSeccion = secciones;
			that.opcionesSelectorSeccion = that.opcionesSelectorSeccion.filter( (a:any) => a.Nombre !== null && a.Nombre !== 'Default')
			that.opcionesSelectorSeccion.sort((one: any, two: any) => {
				var textA = one.Nombre.toUpperCase();
				var textB = two.Nombre.toUpperCase();
				return textA.localeCompare(textB);
			});
			that.auxOpcionesSelectorSeccion = that.opcionesSelectorSeccion;
		});


		this.opcionesTimeSelector = [
			{
				value: 0,
				label: this.translate.instant('Informes.Desactivado')// 'Desactivado'
			},
			{
				value: 1,
				label: this.translate.instant('Informes.minuto_1')// '1 minuto'
			},
			{
				value: 2,
				label: this.translate.instant('Informes.minuto_15')// '15 minutos'
			},
			{
				value: 3,
				label: this.translate.instant('Informes.hora_1')// '1 hora'
			}
		];

		this.opcionesTimeCoincidenciaSelector = [
			{
				value: 0,
				label: this.translate.instant('Informes.mas_minuto_1')// '1 minuto'
			},
			{
				value: 1,
				label: this.translate.instant('Informes.mas_minuto_15')// '15 minutos'
			},
			{
				value: 2,
				label: this.translate.instant('Informes.mas_hora_1')// '1 hora'
			}
		];

		this.opcionesTimeLastToShowSelector = [
			{
				value: 0,
				label: 'hace más de ' + this.translate.instant('Informes.minuto_1')// '1 minuto'
			},
			{
				value: 1,
				label: 'hace más de ' + this.translate.instant('Informes.minuto_15')// '15 minutos'
			},
			{
				value: 2,
				label: 'hace más de ' + this.translate.instant('Informes.hora_1')// '1 hora'
			},
			{
				value: 3,
				label: 'hace más de ' + this.translate.instant('Informes.hora_2')// '1 hora'
			},
			{
				value: 4,
				label: 'hace más de ' + this.translate.instant('Informes.hora_24')// '24 hora'
			},
			{
				value: 5,
				label: this.translate.instant('Informes.sin_limit')// 'sin limite de tiempo'
			},
		];
		this.opcionesTiempoUbicacionSelector = [
			{
				value: 0,
				label: this.translate.instant('Informes.sin_limit')// 'sin limite de tiempo'
			},
			{
				value: 10,
				label: 'es menor a ' + this.translate.instant('Informes.10_min')// '10 minutos'
			},
			{
				value: 20,
				label: 'es menor a ' + this.translate.instant('Informes.20_min')// '20 minutos'
			},
			{
				value: 30,
				label: 'es menor a ' + this.translate.instant('Informes.30_min')// '30 minutos'
			},
			{
				value: 40,
				label: 'es menor a ' + this.translate.instant('Informes.40_min')// '40 minutos'
			},
			{
				value: 50,
				label: 'es menor a ' + this.translate.instant('Informes.50_min')// '50 minutos'
			},
			{
				value: 60,
				label: 'es menor a ' + this.translate.instant('Informes.60_min')// '60 minutos'
			},
		];
		

		this.TimeCoincidencia_selected = 0;
		this.tipo_informe_seleccionado = this.VISTA_LOCALIZACION_TIEMPO_REAL;

		this.time_last_to_show_selected = 1;
		this.menuTipoInformeChange('Vista por defecto: Informe Localizacion Tiempo Real');
		if (this.autorefrescoChecked){
			this.timeRefreshChanged('Time to refresh by default');
		}




		this.activarAutorefreshToken();
	}

	ngOnDestroy(): void {
		this.desactivarAutorefreshToken();
		this.entityManager.RejectChanges();
	}

	activarAutorefreshTablaTiempoReal(){
		const that = this;
		this.fechaInicioAutoRefrescoTablaTiempoReal = new Date();
		this.everyMin = timer(0, this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL * 1000);
		this.subscriptionRenovarTablaTiempoReal = this.everyMin
		.subscribe((seconds) => {
			if (that.autorefrescoChecked) {
				that.fechaAutoRefrescoTablaTiempoReal = new Date(that.fechaInicioAutoRefrescoTablaTiempoReal.getTime());
				that.fechaAutoRefrescoTablaTiempoReal.setSeconds(that.fechaInicioAutoRefrescoTablaTiempoReal.getSeconds() + seconds * this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL);
				that.refrescarTablaTiempoReal(undefined);
			}
		});

	}

	desactivarAutorefreshTablaTiempoReal(){
		if (this.subscriptionRenovarTablaTiempoReal) {
			this.subscriptionRenovarTablaTiempoReal.unsubscribe();
		}
	}


	activarAutorefreshToken(){
		const that = this;
		this.fechaInicioAutoRefrescoToken = new Date();
		this.everyMin = timer(0, this.TIEMPO_AUTOREFRESCO_TOKEN * 1000);
		this.subscriptionRenovarToken = this.everyMin
		.subscribe((seconds) => {
			if (that.autorefrescoChecked) {
				that.fechaAutoRefrescoToken = new Date(that.fechaInicioAutoRefrescoToken.getTime());
				that.fechaAutoRefrescoToken.setSeconds(that.fechaInicioAutoRefrescoToken.getSeconds() + seconds * this.TIEMPO_AUTOREFRESCO_TOKEN);
				that.authService.NewToken();
			}
		});

	}

	desactivarAutorefreshToken(){
		if (this.subscriptionRenovarToken) {
			this.subscriptionRenovarToken.unsubscribe();
		}
	}

	inputChanged(event, value) {
		const that = this;
		if (value === 'menuTipoInformeChange') {
			this.tipo_informe_seleccionado = event.value;
			this.menuTipoInformeChange(event);
		}
		if (value === 'menuSeccionChange') {
			this.secciones_seleccionados = event.value;
			this.menuSeccionChange(event);
		}
		if (value === 'menuTipologiaSeccionChange') {
			this.tipologias_seccion_seleccionadas = event.value;
			this.menuTipologiaSeccionChange(event);
		}
		if (value === 'menuTipologiaContenidoChange') {
			this.tipologias_contenido_seleccionadas = event.value;
			this.menuTipologiaContenidoChange(event);
		}
		if (value === 'menuContenidoChange') {
			this.contenidos_seleccionados = event.value;
			this.menuContenidoChange(event);
		}
		if (value === 'fecha_desde') {
			this.inputFechaChanged(event);
		}
		if (value === 'fecha_hasta') {
			this.inputFechaChanged(event);
		}
		if (value === 'TimeRefreshChange'){
			this.time_selected = event.value;
			this.timeRefreshChanged(event);
		}
		if (value === 'TimeCoincidenciaChange'){
			this.TimeCoincidencia_selected = event.value;
			this.TimeCoincidenciaChanged(event);
		}

		if (value === 'TimeLastToShowChange'){
			this.time_last_to_show_selected = event.value;
			this.timeLastToShowChanged(event);

		}
		if(value === 'duractionUbicationChange'){
			this.time_ubication = event.value;
		}

		this.validar();
	}
	//modificar y descomentar para que salte el error cuando no haya info en las tablas

	validar2(): boolean{
		let p9Error = this.informesList.length === 0 && this.validar();
		let p10Error = this.historicosList.length === 0 && this.validar();
		let p11Error = this.coincidenciasList.length === 0 && this.validar();
		if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){
			if(p9Error){

				this.NoHayInfoError1 = true;
			}
			else{
				this.NoHayInfoError1 = false;

			}
		}
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_LOCALIZACION || this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_SECCION || this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_TIPOLOGIA_SECCION){
			if(p10Error){

				this.NoHayInfoError2 = true;
			}
			else{
				this.NoHayInfoError2 = false;

			}
		}
		if (this.tipo_informe_seleccionado === this.VISTA_COINCIDENCIAS_UBICACION){
			if(p11Error){

				this.NoHayInfoError3 = true;
			}
			else{
				this.NoHayInfoError3 = false;

			}
		}

		return  !p9Error || !p10Error || !p11Error;

	}
	validar(): boolean {
		// Validacion
		const p1Error = this.tipo_informe_seleccionado === undefined || this.tipo_informe_seleccionado === null;
		const p2Error = this.tipologias_contenido_seleccionadas === null || this.tipologias_contenido_seleccionadas === undefined || this.tipologias_contenido_seleccionadas.length === 0;
		let p3Error = this.contenidos_seleccionados === null || this.contenidos_seleccionados === undefined || this.contenidos_seleccionados.length === 0; // this.espacioSeleccionado.FechaAlta === undefined || this.espacioSeleccionado.FechaAlta === null;
		let p4Error = this.opcion_desde_selected === undefined || this.opcion_desde_selected === null; // this.contenidos_seleccionados.fDesdeError.toString() === ''  || this.fDesdeError === undefined  || this.fDesdeError === null;
		let p5Error = this.opcion_hasta_selected === undefined || this.opcion_hasta_selected === null; // this.rutaSeleccionada.FechaBaja === ''  || this.rutaSeleccionada.FechaBaja === undefined  || this.rutaSeleccionada.FechaBaja === null
		// let p6Error = this.contenidos_seleccionados.length >= 11;
		let p6Error = false;
		let p7Error = this.contenidos_seleccionados.length < 2;
		let p8Error = false;

		// const p8Error = this.time_selected === undefined || this.time_selected === null;
		/*
		VISTA_LOCALIZACION_TIEMPO_REAL = 0;
		VISTA_HISTORICOS_LOCALIZACION = 1;
		VISTA_COINCIDENCIAS_UBICACION = 2;
		VISTA_OCUPACION = 3;
		*/
		// VISTA_LOCALIZACION_TIEMPO_REAL no usa Fechas mi minimo 2 contenidos
		if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){
			p4Error = false;
			p5Error = false;
			p7Error = false;
			if (this.tipologias_contenido_seleccionadas.find(  t => t.Tipo === 'CIUDADANO' )){
				p3Error = false;
				p6Error = false;
			}
		}
		// VISTA_HISTORICOS_LOCALIZACION y VISTA_HISTORICOS_SECCION no usa minimo 2 contenidos
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_LOCALIZACION || this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_SECCION || this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_TIPOLOGIA_SECCION){
			p7Error = false;

			p6Error = this.contenidos_seleccionados.length > 4;
		}
		// VISTA_COINCIDENCIAS_UBICACION vamos a permitir pintar coincidencias de uno con todos los demas
		if (this.tipo_informe_seleccionado === this.VISTA_COINCIDENCIAS_UBICACION){
			p7Error = false;
			p8Error = this.TimeCoincidencia_selected !== undefined ? true : false;
		}

		if (p1Error) {
			this.menuTipoInformeError = true;
		}
		else {
			this.menuTipoInformeError = false;
		}

		if (p2Error) {
			this.menuTipologiaContenidoError = true;
		}
		else {
			this.menuTipologiaContenidoError = false;
		}

		if (p3Error) {
			this.menuContenidoError = true;
		}
		else {
			this.menuContenidoError = false;
		}

		if (p4Error) {
			this.fDesdeError = true;
		}
		else {
			this.fDesdeError = false;
		}

		if (p5Error) {
			this.fHastaError = true;
		}
		else {
			this.fHastaError = false;
			this.inputFechaChanged(event);
		}
		if (p6Error) {
			this.maxRows = true;
		}
		else {
			this.maxRows = false;
		}
		if (p7Error) {
			this.minRows = true;
		}
		else {
			this.minRows = false;
		}

		if (p8Error){
			this.tiempoMinimoCoincidenciaError = true;
		}
		else {
			this.tiempoMinimoCoincidenciaError = false;
		}


		return !p1Error &&  !p2Error && !p3Error && !p4Error && !p5Error && !p6Error && !p7Error;
	}

    menuTipoInformeChange(event){
        console.log( '*** INFORME HA CAMBIADO');
		this.informesList = [];
		this.historicosList = [];
		this.TablitaList = [];
		this.coincidenciasList = [];
		this.tipologias_contenido_seleccionadas = [];
		this.contenidos_seleccionados = [];
		this.secciones_seleccionados = [];
		this.tipologias_seccion_seleccionadas = [];
		this.time_ubication = 0;
		this.opcion_desde_selected = undefined;
		this.opcion_hasta_selected = undefined;


		// this.tipo_informe_seleccionado = event.value;
		this.refrescarTablasVisibles();
    }

	timeRefreshChanged(event){
		console.log( '*** TIME TO REFRESH CHANGED');

		if (this.time_selected === 0){
			this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL = 0; // Desactivado
			this.desactivarAutorefreshTablaTiempoReal();
			this.desactivarAutorefreshToken();
		}
		else if (this.time_selected === 1){
			this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL = 60; // 1 minuto
			this.desactivarAutorefreshTablaTiempoReal();
			this.desactivarAutorefreshToken();
		}
		else if (this.time_selected === 2){
			this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL = 900; // 15 minutos
			this.desactivarAutorefreshTablaTiempoReal();
			this.desactivarAutorefreshToken();
		}
		else if (this.time_selected === 3){
			this.TIEMPO_AUTOREFRESCO_TABLA_TIEMPO_REAL = 3600; // 1 hora
			this.desactivarAutorefreshTablaTiempoReal();
			this.desactivarAutorefreshToken();
		}

		this.activarAutorefreshTablaTiempoReal();
		this.activarAutorefreshToken();
	}

	TimeCoincidenciaChanged(event) {
	}

	timeLastToShowChanged(event){
	}
    menuTipologiaContenidoChange(event){
		this.refrescarContenidosTipologiasSeleccionadas(event);
	}
	menuTipologiaSeccionChange(event){
		this.refrescarSeccionesTipologiasSeleccionadas(event);
	}
	menuSeccionChange(event){
	}

	menuContenidoChange(event){
	}

	inputFechaChanged(event){
	}


	onFechaAceptar(dt, calendar, columna, tipo) {
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'Desde') {
			this.opcion_desde_selected = fecha;
		}
		if (tipo === 'Hasta') {
			this.opcion_hasta_selected = fecha;
		}

		this.inputChanged(undefined,columna);
		calendar.overlayVisible=false;
	}


	refrescarContenidosTipologiasSeleccionadas(event){
		const that = this;
		const esSeleccionMultiple = event ? event.value.length > 1 : false;
		let EsCiudadano = false;

		if (esSeleccionMultiple) {

			// Miro a ver si habia varios seleccionados y ahora selecciono CIUDADANO
			EsCiudadano = event && event.itemValue ? event.itemValue.Tipo === 'CIUDADANO' : false;

			// Como no seleccionamos ciudadano la desmarcamos
			if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL) {
				if (EsCiudadano) {
					this.tipologias_contenido_seleccionadas = this.tipologias_contenido_seleccionadas.filter(t => t.Tipo === 'CIUDADANO');
				}
				else {
					this.tipologias_contenido_seleccionadas = this.tipologias_contenido_seleccionadas.filter(t => t.Tipo !== 'CIUDADANO');
				}
			}
		}
		else{
			EsCiudadano = event && event.itemValue  ? event.itemValue.Tipo === 'CIUDADANO' : false;
		}

		// Si hay, elimino las seleccionadas y meto unicamente las de CIUDADANO
		if (EsCiudadano && this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){

			this.tipologias_contenido_seleccionadas = this.tipologias_contenido_seleccionadas.filter(t => t.Id === event.itemValue.Id);
			const listaIdsTipologias = this.tipologias_contenido_seleccionadas.map(tipologia => {
					return tipologia.Id;
				});

			// SELECCIONADO TODO Y DESHABILITADO
			this.informeService.obtenerContenidosByTipologiad(listaIdsTipologias, undefined)
			.then(function(contenidosTipologias){
				that.opcionesSelectorContenido = contenidosTipologias;
				that.opcionesSelectorContenido.sort((one: any, two: any) => {
					var textA = one.label.toUpperCase();
					var textB = two.label.toUpperCase();
					return textA.localeCompare(textB);
				});
				that.contenidos_seleccionados = [];
				that.opcionesSelectorContenido.forEach(contenidoTipologia => {
				that.contenidos_seleccionados.push(contenidoTipologia.Id);
				});
			});

		}
		else{
			// Como no seleccionamos ciudadano la desmarcamos
			if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL) {
				this.tipologias_contenido_seleccionadas = this.tipologias_contenido_seleccionadas.filter(t => t.Tipo !== 'CIUDADANO');
			}

			const listaIdsTipologias = this.tipologias_contenido_seleccionadas.map(tipologia => {
				return tipologia.Id;
			});

			this.informeService.obtenerContenidosByTipologiad(listaIdsTipologias, undefined)
			.then(function(contenidosTipologias){
				that.opcionesSelectorContenido = contenidosTipologias;
				that.opcionesSelectorContenido.sort((one: any, two: any) => {
					var textA = one.label.toUpperCase();
					var textB = two.label.toUpperCase();
					return textA.localeCompare(textB);
				});
				// Quitar de la lista contenidos_seleccionados todos los contenidos de una tipologia que no este el la lista tipologias_contenido_seleccionadas
				const contenidos_seleccionados_aux = [];
				that.opcionesSelectorContenido.forEach(contenidoTipologia => {
					const seleccionado = that.contenidos_seleccionados.find( c => c === contenidoTipologia.Elemento);
					if (seleccionado) {
						contenidos_seleccionados_aux.push(contenidoTipologia.Id);
					}
				});
				that.contenidos_seleccionados = contenidos_seleccionados_aux;
			});
		}
	}

	refrescarSeccionesTipologiasSeleccionadas(event){
		const that = this;
		const listaIdsTipologias = this.tipologias_seccion_seleccionadas.map(tipologia => {
			return tipologia.Id;
		});
		that.opcionesSelectorSeccion = that.auxOpcionesSelectorSeccion;
		if(listaIdsTipologias.length > 0){
			let array = [];
			that.opcionesSelectorSeccion.forEach(seccion => {
				let entidadSeccion = new SeccionFormulario().fromENTIDAD(seccion);
				
				if(entidadSeccion.TIPOLOGIAS_SECCION && entidadSeccion.TIPOLOGIAS_SECCION.length > 0){
					console.log(entidadSeccion)
					entidadSeccion.TIPOLOGIAS_SECCION.forEach(Tipologias => {
						if(listaIdsTipologias.find( t => t === Tipologias.Id)){
							if(!array.find(s => s === seccion)){
								array.push(seccion);
							}
							
						}
					});
				}
			});
			array.sort((one: any, two: any) => {
				var textA = one.Nombre.toUpperCase();
				var textB = two.Nombre.toUpperCase();
				return textA.localeCompare(textB);
			});
			that.opcionesSelectorSeccion = array;
		}else{

			that.opcionesSelectorSeccion = that.auxOpcionesSelectorSeccion;
		}
		
		



	}


	refrescarTablaTiempoReal(cont, sec?){
		const that = this;
		this.spinner.style.display = 'inherit';
		let listaSecciones;
		let listaIdsContenidos = this.contenidos_seleccionados.map(contenido => {
			return contenido;
		});
		let TIEMPO_MOSTRAR = 0;
		if (this.time_last_to_show_selected === 0){
			TIEMPO_MOSTRAR = 1; // 1 minuto
		}
		else if (this.time_last_to_show_selected === 1){
			TIEMPO_MOSTRAR = 15; // 15 minutos
		}
		else if (this.time_last_to_show_selected === 2){
			TIEMPO_MOSTRAR = 60; // 1 hora
		}
		else if (this.time_last_to_show_selected === 3){
			TIEMPO_MOSTRAR = 120; // 2 hora
		}
		else if (this.time_last_to_show_selected === 4){
			TIEMPO_MOSTRAR = 60 * 24; // Un dia
		}
		else if (this.time_last_to_show_selected === 5){
			TIEMPO_MOSTRAR = 0; // Sin limite de tiempo
		}
		if(this.secciones_seleccionados){
			listaSecciones = this.secciones_seleccionados.map(seccion => {
				return seccion.Nombre;
			});
		}
		let idsTipologia = [];
		if (this.tipologias_contenido_seleccionadas) {
			idsTipologia = this.tipologias_contenido_seleccionadas.map(tipo => {
				return tipo.Id;
			});
		}
		this.informeService.obtenerLocalizacionTiempoReal_3(listaIdsContenidos, TIEMPO_MOSTRAR , undefined, listaSecciones, idsTipologia)
		.then(function(informes: Contenido[]){
			informes = informes.filter(h => h.Ala !== undefined)
			informes = informes.filter(h => h.Nivel !== undefined)
			that.informesList = informes;
			that.tipologiasMostrar = that.tipologias_contenido_seleccionadas;
			that.spinner.style.display = 'none';
			that.mostrarNoHayResusltado();
		});
	}

	refrescarTablaHistoricos(cont){
		const that = this;
		let listaSecciones;
		this.spinner.style.display = 'inherit';
		const listaIdsHistoricos = this.contenidos_seleccionados.map(historico => {
			return historico;
		});
		if(this.secciones_seleccionados){
			listaSecciones = this.secciones_seleccionados.map(seccion => {
				return seccion.Nombre;
			});
		}
		this.informeService.obtenerHistoricoLocalizacionesContenidos(cont, this.opcion_desde_selected, this.opcion_hasta_selected, this.time_ubication, undefined, listaSecciones)
		.then(function(Historicos: HistoricoLocalizacionContenido[]){
			// Orden por defecto de la tabla -> elemento - fechaDesde - fechaHasta
			Historicos = Historicos.filter(h => h.Ala !== undefined)
			Historicos = Historicos.filter(h => h.Nivel !== undefined)
			that.historicosList = Historicos;
			that.tipologiasMostrar = that.tipologias_contenido_seleccionadas;
			that.spinner.style.display = 'none';
			that.mostrarNoHayResusltado();
		});
	}

	refrescarTablaHistoricosSeccion(cont){
		const that = this;
		let listaSecciones;
		this.spinner.style.display = 'inherit';
		if(this.secciones_seleccionados){
			listaSecciones = this.secciones_seleccionados.map(seccion => {
				return seccion.Nombre;
			});
		}
		this.informeService.obtenerHistoricoLocalizacionesContenidos(cont, this.opcion_desde_selected, this.opcion_hasta_selected, this.time_ubication, undefined, listaSecciones)
		.then(function(Historicos: HistoricoLocalizacionContenido[]){
			// Orden por defecto de la tabla -> elemento - fechaDesde - fechaHasta
			Historicos = Historicos.filter(h => h.Ala !== undefined)
			Historicos = Historicos.filter(h => h.Nivel !== undefined)
			that.historicosList = Historicos;
			that.tipologiasMostrar = that.tipologias_contenido_seleccionadas;
			that.contenidosMostrar = [];
			that.contenidos_seleccionados.forEach(contenido => {
				const seleccionado = that.opcionesSelectorContenido.find(o => contenido === o.Id);
				if(seleccionado){
					let obj = {value: seleccionado.Id, label: seleccionado.Elemento}
					that.contenidosMostrar.push(obj)
				}
			});
			that.spinner.style.display = 'none';
			that.mostrarNoHayResusltado();
		});
	}

	refrescarTablaHistoricosTipologiaSeccion(cont){
		const that = this;
		let listaTipologias;
		this.spinner.style.display = 'inherit';
		if(that.tipologias_seccion_seleccionadas){
			listaTipologias = this.tipologias_seccion_seleccionadas.map(tipo => {
				return tipo.Nombre;
			});
		}
		this.informeService.obtenerHistoricoLocalizacionesContenidos(cont, this.opcion_desde_selected, this.opcion_hasta_selected, this.time_ubication, undefined, undefined, listaTipologias)
		.then(function(Historicos: HistoricoLocalizacionContenido[]){
			// Orden por defecto de la tabla -> elemento - fechaDesde - fechaHasta
			Historicos = Historicos.filter(h => h.Ala !== undefined)
			Historicos = Historicos.filter(h => h.Nivel !== undefined)
			that.historicosList = Historicos;
			that.tipologiasSeccionesMostrar = [];
			that.historicosList.forEach(elemento => {
				if(elemento.SeccionFormulario.TIPOLOGIAS_SECCION && elemento.SeccionFormulario.TIPOLOGIAS_SECCION.length > 0){
					let existeTipologia = that.tipologiasSeccionesMostrar.find(t => t.Id === elemento.SeccionFormulario.TIPOLOGIAS_SECCION[0].Id)
					if(!existeTipologia){
						that.tipologiasSeccionesMostrar.push(elemento.SeccionFormulario.TIPOLOGIAS_SECCION[0]);
					}
				}
			});
			that.tipologiasSeccionesMostrar.sort((one: any, two: any) => {
				var textA = one.Nombre.toUpperCase();
				var textB = two.Nombre.toUpperCase();
				return textA.localeCompare(textB);
			});
			that.tipologiasMostrar = that.tipologias_contenido_seleccionadas;
			that.contenidosMostrar = [];
			
			that.contenidos_seleccionados.forEach(contenido => {
				const seleccionado = that.opcionesSelectorContenido.find(o => contenido === o.Id);
				if(seleccionado){
					let obj = {value: seleccionado.Id, label: seleccionado.Elemento}
					that.contenidosMostrar.push(obj)
				}
			});
			console.log(that.contenidosMostrar)
			that.spinner.style.display = 'none';
			that.mostrarNoHayResusltado();
		});
	}

	refrescarTablaCoincidencias(cont){
		const that = this;
		this.spinner.style.display = 'inherit';
		const listaIdsCoincidencias = this.contenidos_seleccionados.map(coincidencia => {
			return coincidencia;
		});
		this.informeService.obtenerCoincidenciasLocalizacionContenidos(cont, this.opcion_desde_selected, this.opcion_hasta_selected)
		.then(function(Coincidencias: CoincidenciasLocalizacionContenidos[]){
			Coincidencias = Coincidencias.filter(h => h.Ala !== undefined)
			Coincidencias = Coincidencias.filter(h => h.Nivel !== undefined)
			that.coincidenciasList = that.filtrarConincidenciasPorTiempoCoincidencia(Coincidencias);
			that.spinner.style.display = 'none';
			that.mostrarNoHayResusltado();
		});
	}

	filtrarConincidenciasPorTiempoCoincidencia(Coincidencias: CoincidenciasLocalizacionContenidos[]):  CoincidenciasLocalizacionContenidos[]{

		const aux = [];
		let TIEMPO_MINIMO = 0;
		if (this.TimeCoincidencia_selected === 0){
			TIEMPO_MINIMO = 1; // 1 minuto
		}
		else if (this.TimeCoincidencia_selected === 1){
			TIEMPO_MINIMO = 15; // 15 minutos
		}
		else if (this.TimeCoincidencia_selected === 2){
			TIEMPO_MINIMO = 60; // 1 hora
		}

		Coincidencias.forEach(element => {
			if (element.tiempo_coincidencia > TIEMPO_MINIMO) {
				aux.push(element);
			}
		});

		return aux;
	}

	mostrarNoHayResusltado(){
		const ok = this.validar2();
		let mensaje_error = '';
		if (!ok) {

			if (this.NoHayInfoError1) {
				mensaje_error = this.translate.instant('Informes.NoHayInfoError');
			}
			else if (this.NoHayInfoError2) {
				mensaje_error = this.translate.instant('Informes.NoHayInfoError');
			}
			else if (this.NoHayInfoError3) {
				mensaje_error = this.translate.instant('Informes.NoHayInfoError');
			}

			this.showInfo(mensaje_error);

		}

		return ok;
	}

	refrescarTablasVisibles(){
		this.desactivarAutorefreshTablaTiempoReal();
		this.desactivarAutorefreshToken();
		//this.authService.NewToken(); //añadido en subscription para auto renovar
		// TIEMPO REAL
		if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){
			this.ocultarAutorefrescar = false;
			this.ocultarTimeAutorefrescar = false;
			this.ocultarTimeCoincidencia = true;
			this.ocultarDesdeHasta = true;
			this.ocultarfiltrar = false;
			this.OcultarExportar = false;
			this.duracionUbicacion = false;

			this.ocultarVistaLocalizacionActual = false;
			this.ocultarVistaHistoricos = true;
			this.ocultarVistaSecciones = true;
			this.ocultarVistaOcupacion = true;
			this.ocultarVistaCoincidencias = true;
			this.ocultarVistaTipologiaSecciones = true;
			this.tablitaVisible = false;
			this.ocultarMostrarSecciones = true;


			this.activarAutorefreshTablaTiempoReal();
			this.activarAutorefreshToken();

			this.refrescarTablaTiempoReal(this.contenidos_seleccionados, this.secciones_seleccionados);


		}
		// HISTORICOS
		else if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_LOCALIZACION){
			this.ocultarAutorefrescar = true;
			this.ocultarTimeAutorefrescar = true;
			this.ocultarTimeCoincidencia = true;
			this.ocultarDesdeHasta = false;
			this.ocultarfiltrar = false;
			this.OcultarExportar = false;
			this.duracionUbicacion = true;

			this.ocultarVistaLocalizacionActual = true;
			this.ocultarVistaHistoricos = false;
			this.ocultarVistaSecciones = true;
			this.ocultarVistaOcupacion = true;
			this.ocultarVistaCoincidencias = true;
			this.ocultarVistaTipologiaSecciones = true;
			this.tablitaVisible = true;
			this.ocultarMostrarSecciones = false;

			this.refrescarTablaHistoricos(this.contenidos_seleccionados);
		}
		// HISTORICOS POR SECCION
		else if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_SECCION ){
			this.ocultarAutorefrescar = true;
			this.ocultarTimeAutorefrescar = true;
			this.ocultarTimeCoincidencia = true;
			this.ocultarDesdeHasta = false;
			this.ocultarfiltrar = false;
			this.OcultarExportar = false;
			this.duracionUbicacion = true;

			this.ocultarVistaLocalizacionActual = true;
			this.ocultarVistaHistoricos = true;
			this.ocultarVistaSecciones = false;
			this.ocultarVistaOcupacion = true;
			this.ocultarVistaCoincidencias = true;
			this.ocultarVistaTipologiaSecciones = true;
			this.tablitaVisible = true;
			this.ocultarMostrarSecciones = false;

			this.refrescarTablaHistoricosSeccion(this.contenidos_seleccionados);
		}
		// COINCIDENCIAS
		else if (this.tipo_informe_seleccionado === this.VISTA_COINCIDENCIAS_UBICACION ){
			this.ocultarAutorefrescar = true;
			this.ocultarTimeAutorefrescar = true;
			this.ocultarTimeCoincidencia = false;
			this.ocultarDesdeHasta = false;
			this.ocultarfiltrar = false;
			this.OcultarExportar = false;
			this.duracionUbicacion = false;

			this.ocultarVistaLocalizacionActual = true;
			this.ocultarVistaHistoricos = true;
			this.ocultarVistaSecciones = true;
			this.ocultarVistaOcupacion = true;
			this.ocultarVistaCoincidencias = false;
			this.ocultarVistaTipologiaSecciones = true;
			this.ocultarMostrarSecciones = true;

			this.refrescarTablaCoincidencias(this.contenidos_seleccionados);
		}
		// OCUPACION
		else if (this.tipo_informe_seleccionado === this.VISTA_OCUPACION ){
			this.ocultarAutorefrescar = true;
			this.ocultarTimeAutorefrescar = true;
			this.ocultarTimeCoincidencia = true;
			this.ocultarDesdeHasta = true;
			this.ocultarfiltrar = true;
			this.OcultarExportar = true;
			this.duracionUbicacion = false;

			this.ocultarVistaLocalizacionActual = true;
			this.ocultarVistaHistoricos = true;
			this.ocultarVistaSecciones = true;
			this.ocultarVistaOcupacion = false;
			this.ocultarVistaCoincidencias = true;
			this.ocultarVistaTipologiaSecciones = true;
			this.ocultarMostrarSecciones = true;

		}// HISTORICOS POR TIPOLOGIA DE SECCION
		else if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_TIPOLOGIA_SECCION ){
			this.ocultarAutorefrescar = true;
			this.ocultarTimeAutorefrescar = true;
			this.ocultarTimeCoincidencia = true;
			this.ocultarDesdeHasta = false;
			this.ocultarfiltrar = false;
			this.OcultarExportar = false;
			this.duracionUbicacion = true;

			this.ocultarVistaLocalizacionActual = true;
			this.ocultarVistaHistoricos = true;
			this.ocultarVistaSecciones = true;
			this.ocultarVistaOcupacion = true;
			this.ocultarVistaCoincidencias = true;
			this.ocultarVistaTipologiaSecciones = false;
			this.tablitaVisible = true;
			this.ocultarMostrarSecciones = false;

			this.refrescarTablaHistoricosTipologiaSeccion(this.contenidos_seleccionados);
		}

	}
	TipologiaCiudadanoSeleccionado(){

		const esCiudadano = this.tipologias_contenido_seleccionadas.find( t => t.Tipo === 'CIUDADANO' );
		if (esCiudadano &&  this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){
			return true;
		}
		else{
			return false;
		}
	}
    setScale(contenedorPlano, anchoMapa) {
        return (contenedorPlano.offsetWidth - 30) / anchoMapa;
	}

	filtrar(event){
		console.log(event);
		const that =  this;
		const mensaje_error = '';
		if (this.mostrarResusltadoValidacion()) {
			this.refrescarTablasVisibles();
			that.fechaAutoRefrescoTablaTiempoReal = new Date(that.fechaInicioAutoRefrescoTablaTiempoReal.getTime());
			that.fechaAutoRefrescoTablaTiempoReal.setSeconds(that.fechaInicioAutoRefrescoTablaTiempoReal.getSeconds());
		}
	}
	mostrarResusltadoValidacion(){
		const ok = this.validar();
		let mensaje_error = '';
		if (!ok) {

			// Tipo Informe
			if (this.menuTipoInformeError){
				mensaje_error += 	this.translate.instant('Informes.menuTipoInformeError');
			}

			// Tipo Contenido
			if (this.menuTipologiaContenidoError){
				mensaje_error += this.translate.instant('Informes.menuTipologiaContenidoError');
			}

			// Contenidos
			if (this.minRows){
				mensaje_error += this.translate.instant('Informes.minRows');
			}
			if (this.maxRows){
				mensaje_error += this.translate.instant('Informes.maxRows');
			}
			if (!this.minRows && this.menuContenidoError) {
				mensaje_error += this.translate.instant('Informes.menuContenidoError');
			}

			// Fechas
			if (this.fDesdeError){
				mensaje_error += this.translate.instant('Informes.fDesdeError');
			}
			if (this.fHastaError){
				mensaje_error += this.translate.instant('Informes.fHastaError');
			}

			// Coincidencia
			if (this.tiempoMinimoCoincidenciaError) {
				mensaje_error += this.translate.instant('Informes.tiempoMinimoCoincidenciaError');
			}

			this.showError(mensaje_error);

		}
		return ok;
	}
    /****** AUX ********/
	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	public setHistoricosLocalStorage(hist) {
		const getCircularReplacer = () => {
			const seen = new WeakSet();
			return (key, value) => {
			  if (typeof value === "object" && value !== null) {
				if (seen.has(value)) {
				  return;
				}
				seen.add(value);
			  }
			  return value;
			};
		};

		const cadenaHistoricos = JSON.stringify(hist, getCircularReplacer());

		localStorage.setItem('historicos',  cadenaHistoricos);
	}

	exportarPlano(){
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_LOCALIZACION ){
			window.print();
		}
		else {
			console.log('TODO: Exportar svg');
		}
	}
	exportarContenido(){
		// this.loadContenido(true);
		this.loadContenidoExportar();
	}
	loadContenidoExportar() {

		const that = this;

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const columnas = [];

		const first = 0;
		const size = 1000000000000;

		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const Hasta =  this.filtro.Hasta;

		// Según la vista en la que se está de la pestaña informes
		if (this.tipo_informe_seleccionado === this.VISTA_LOCALIZACION_TIEMPO_REAL){
			console.log('Se va a exportar documento en VISTA_LOCALIZACION_TIEMPO_REAL');

			const excluidos = new Array();

			that.exportador.exportarXLS(that.exportador.generarHojaLocalizaciones(that.informesList), 'Localizacion');
			that.triggerPageChange = false;
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();

		}
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_LOCALIZACION){
			console.log('Se va a exportar documento en VISTA_HISTORICOS_LOCALIZACION');

			const excluidos = new Array();

			that.exportador.exportarXLS(that.exportador.generarHojaLocahistoricos(that.historicosList), 'historicos');

			that.triggerPageChange = false;
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		}
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_SECCION){
			console.log('Se va a exportar documento en VISTA_HISTORICOS_SECCION');

			const excluidos = new Array();

			that.exportador.exportarXLS(that.exportador.generarHojaLocahistoricos(that.historicoSeccionesList), 'historicoSecciones');

			that.triggerPageChange = false;
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		}
		if (this.tipo_informe_seleccionado === this.VISTA_COINCIDENCIAS_UBICACION){
			console.log('Se va a exportar documento en VISTA_COINCIDENCIAS_UBICACION');

			const excluidos = new Array();

			that.exportador.exportarXLS(that.exportador.generarHojaLocacoincidencias(that.coincidenciasList), 'coincidencias');

			that.triggerPageChange = false;
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		}
		if (this.tipo_informe_seleccionado === this.VISTA_HISTORICOS_TIPOLOGIA_SECCION){
			console.log('Se va a exportar documento en VISTA_HISTORICOS_SECCION');

			const excluidos = new Array();

			that.exportador.exportarXLS(that.exportador.generarHojaLocahistoricos(that.historicoTipologiaSeccionesList), 'historicoTipologiaSecciones');

			that.triggerPageChange = false;
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		}


	}

	exportarContenidoAgrupadoSecciones(datos){
		this.historicoSeccionesList = datos;
	}
	exportarContenidoAgrupadoTipologiaSecciones(datos){
		this.historicoTipologiaSeccionesList = datos;
	}


	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}
	protected showInfo = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'info',  detail: mensaje});
	}

	descripcionInforme(event){
		console.log(event)
		console.log(this.tipo_informe_seleccionado)
		this.positionDialogInfoInformeX = event.x;
		this.positionDialogInfoInformeY = event.y;
		this.dialogDescripcionInforme = true;
		if(this.tipo_informe_seleccionado === 0){
			this.infoInforme="Descripción Informe Localización Tiempo Real"
		}else if(this.tipo_informe_seleccionado === 1){
			this.infoInforme="Descripción Informe Histórico por Ubicaciones"
		}else if(this.tipo_informe_seleccionado === 2){
			this.infoInforme="Descripción Informe Histórico por Secciones"
		}else if(this.tipo_informe_seleccionado === 3){
			this.infoInforme="Descripción Informe Coincidencias Ubicación"
		}else if(this.tipo_informe_seleccionado === 4){
			this.infoInforme="Descripción Informe Ocupación"
		}

	}
}





// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Informes/Informes.component.ts